import type { HealthSnapshot } from '../api/knowledgeApi'

/** Last observed snapshot per Chicago day; never invent measurements between builds. */
export function dailySnapshots(history: HealthSnapshot[], days: number, now = Date.now()) {
  const cutoff = now - days * 86_400_000
  const daily = new Map<string, HealthSnapshot>()
  for (const point of [...history].sort((a, b) => a.takenAt.localeCompare(b.takenAt))) {
    if (new Date(point.takenAt).getTime() < cutoff) continue
    const day = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Chicago' }).format(
      new Date(point.takenAt)
    )
    daily.set(day, point)
  }
  return [...daily.values()]
}

export const compactCount = (value: number) =>
  new Intl.NumberFormat('en-US', { notation: 'compact', maximumFractionDigits: 1 }).format(value)

/** The aggregate API omits days without events; preserve calendar spacing with zero-event days. */
export function decisionDays(
  rows: Array<{ day: string; proposed: number; autopilot: number; person: number }>,
  days: number,
  observedAt: string
) {
  const lastDay = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Chicago' }).format(
    new Date(observedAt)
  )
  const end = Date.parse(`${lastDay}T12:00:00Z`)
  const byDay = new Map(rows.map((row) => [row.day, row]))
  return Array.from({ length: days }, (_, i) => {
    const day = new Date(end - (days - i - 1) * 86_400_000).toISOString().slice(0, 10)
    return byDay.get(day) ?? { day, proposed: 0, autopilot: 0, person: 0 }
  })
}
